var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('slice-body',{staticClass:"category-body",attrs:{"slices":_vm.doc.data.body,"category":_vm.doc.uid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }